import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TbFileTypeCsv, TbFileTypeXls, TbTableExport } from "react-icons/tb";

import { downloadAsExcel } from "@/helpers/download";
import { ExportTypes } from "@/types/export.types";

function ExportTable({
    handleRequest,
    loading,
    fileName,
    filePrefix,
    disabled = false,
}: {
    loading: boolean;
    fileName: string;
    handleRequest: (format: ExportTypes) => Promise<ArrayBuffer | undefined>;
    filePrefix?: () => string;
    disabled?: boolean;
}) {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const exportTable = async (format: ExportTypes) => {
        handleClose();
        if (loading) return;

        const title = (filePrefix && filePrefix() + t(fileName)) || t(fileName);
        try {
            const res = await handleRequest(format);
            if (res) downloadAsExcel(res, format, title);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <Button
                id="demo-positioned-button"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                disabled={disabled || loading}
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                startIcon={<TbTableExport></TbTableExport>}
                color="secondary"
            >
                {t("buttons.export")}
            </Button>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    className="!flex !items-center !justify-start !gap-2"
                    dense
                    onClick={() => exportTable(ExportTypes.XLSX)}
                >
                    <TbFileTypeXls /> {t("buttons.exportAsExcel")}
                </MenuItem>
                <MenuItem
                    className="!flex !items-center !justify-start !gap-2"
                    dense
                    divider
                    onClick={() => exportTable(ExportTypes.CSV)}
                >
                    <TbFileTypeCsv /> {t("buttons.exportAsCSV")}
                </MenuItem>
            </Menu>
        </>
    );
}

export default ExportTable;
